import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Images } from 'assets/images';
import { ROUTES } from 'utils/routeNames';
import { useFindSuccess } from 'hooks/useFindSuccess';
import { useFindError } from 'hooks/useFindError';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { RESET_PASSWORD_REQUEST } from 'store/auth/types';
import { httpRequestsOnSuccessActions, authActions } from 'store';
import { LoadingButton } from 'components';
import { useFindLoad } from 'hooks/useFindLoad';
import { forgotPasswordScheme } from 'validationSchemes/forgotPasswordSchema';
import { useNavigate } from 'react-router-dom';
import { setStorage } from 'utils/storageHelpers';
import { LazyContainer } from 'components/ImageLazy/styled';
import { ImageLazy } from 'components/ImageLazy';
import {
  ForgotPasswordBlock,
  ForgotPasswordWrapper,
  ForgotPasswordForm,
  InputEmailAndSendButtonBlock,
  CloseIcon,
  TitleOfPage,
  ModalDescription,
  InputEmail,
  StyledButtonContainer,
  CloseIconLink,
  ErrorMessage,
} from './styled';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const success = useFindSuccess(RESET_PASSWORD_REQUEST);
  const requestError = useFindError(RESET_PASSWORD_REQUEST);
  const isLoading = useFindLoad(RESET_PASSWORD_REQUEST);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordScheme),
  });

  const onSubmit = (data) => {
    const { email } = data;
    setStorage('verify_email', email);
    dispatch(authActions.resetPassword(email));
  };

  useEffect(() => {
    if (success.length) {
      navigate(ROUTES.VERIFY_EMAIL);
    } else {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(RESET_PASSWORD_REQUEST));
    }
  }, [success?.length]);

  return (
    <ForgotPasswordWrapper>
      <LazyContainer>
        <ImageLazy
          src={Images.loginMainBackground}
          width="100%"
          height="100%"
          hash="LqBE%hJDxWWBX=xaaxa}x^awWYof"
        />
      </LazyContainer>
      <ForgotPasswordBlock>
        <ForgotPasswordForm onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <TitleOfPage>Forget Password?</TitleOfPage>

          <CloseIconLink to={ROUTES.LOGIN}>
            <CloseIcon src={Images.closeBlueIcon} />
          </CloseIconLink>

          <ModalDescription>
            Enter your email address, and we'll send you a verification code to reset
            your password.
          </ModalDescription>

          <InputEmailAndSendButtonBlock>
            <InputEmail
              autoComplete="off"
              {...register('email')}
              type="text"
              placeholder="Enter Email Address"
              error={errors.email?.message || requestError[0]}
            />
            <ErrorMessage>
              {requestError[0] ? t('emailNotValid') : errors.email?.message}
            </ErrorMessage>
            <StyledButtonContainer>
              <LoadingButton
                width="100%"
                height="54px"
                fs="20px"
                Verify
                loading={isLoading}
                name="Send"
                type="submit"
              />
            </StyledButtonContainer>
          </InputEmailAndSendButtonBlock>
        </ForgotPasswordForm>
      </ForgotPasswordBlock>
    </ForgotPasswordWrapper>
  );
};

export default ForgotPassword;
